module.exports = __webpack_public_path__ + "92ad84eb96bf494fc70b3ab83771f6b4.png";